import { cn } from "@/lib/cn";
import { initials } from "@/lib/format";

export type AvatarProps = {
  name: string;
  url?: string | null | undefined;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | undefined;
  className?: string | undefined;
};

const SIZES = {
  xs: "h-6 w-6 text-[10px]",
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-14 w-14 text-lg",
  xl: "h-24 w-24 text-3xl",
} as const;

function hue(name: string): number {
  let hash = 0;
  for (let index = 0; index < name.length; index += 1) {
    hash = (hash * 31 + name.charCodeAt(index)) % 360;
  }
  return hash;
}

export function Avatar({ name, url, size = "md", className }: AvatarProps) {
  const classes = cn(
    "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold select-none",
    SIZES[size],
    className,
  );

  if (url !== null && url !== undefined && url !== "") {
    return <img alt="" className={cn(classes, "object-cover")} src={url} />;
  }

  return (
    <span
      className={cn(classes, "text-white")}
      style={{ backgroundColor: `oklch(0.58 0.14 ${hue(name)})` }}
    >
      {initials(name)}
    </span>
  );
}
